export const makeFolderCacheName = (folderId) => "folder_" + folderId;

/**
 * @typedef Folder
 * @property waveformsDictionary: {},
 * @property nbooks: number,
 * @property nAudioBooks: number,
 * @property value: number,
 * @property id: number,
 * @property label: string,
 * @property className: string,
 * @property totalCount: number,
 * @property totalAudioCount: number,
 * @property children: Folder[],
 * @property lang: string,
 */

/**
 * @param {{}[]} folders – API folders
 * @param {string} lang – language
 * @returns {{totalAudioCount: number, totalCount: number, outList: Folder[]}}
 */
export const normalizeLanguageFolders = (folders, lang) => {
  if (!folders) {
    return {
      totalCount: 0,
      totalAudioCount: 0,
      outList: []
    };
  }

  let totalCount = 0;
  let totalAudioCount = 0;
  let outList = [];

  folders.forEach((item) => {
    let outChildren = normalizeLanguageFolders(item.children, lang);

    totalCount += item.nbooks;
    totalCount += outChildren.totalCount;
    totalAudioCount += item.naudiobooks;
    totalAudioCount += outChildren.totalAudioCount;

    outList.push({
      nbooks: item.nbooks,
      nAudioBooks: item.naudiobooks,
      value: item.folder_id,
      id: item.folder_id,
      label: item.name,
      className: item.add_class,
      totalCount: outChildren.totalCount,
      totalAudioCount: outChildren.totalAudioCount,
      children: outChildren.outList,
      lang,
    });
  });

  return {
    totalCount,
    totalAudioCount,
    outList
  };
};
